import { render, staticRenderFns } from "./ImageSimple.vue?vue&type=template&id=a39448b6"
import script from "./ImageSimple.vue?vue&type=script&lang=js"
export * from "./ImageSimple.vue?vue&type=script&lang=js"
import style0 from "./ImageSimple.vue?vue&type=style&index=0&id=a39448b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports